import { render, staticRenderFns } from "./StockManage_Default.vue?vue&type=template&id=4360497b&"
import script from "./StockManage_Default.vue?vue&type=script&lang=js&"
export * from "./StockManage_Default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports